import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Alerter, AlerterOperator, AlerterOperators, AlerterStyles } from 'src/app/table-handling/types';

@Directive({
  selector: '[appAlerter]',
  standalone: true,
})
export class AlerterDirective implements OnChanges {
  private static readonly ALERTER_STYLES: AlerterStyles[] = Object.values(AlerterStyles);

  @Input('appAlerter') public alerter: Alerter | null;
  @Input() public value: unknown;

  constructor(private readonly element: ElementRef<HTMLElement>) {}

  public ngOnChanges({ value, alerter }: SimpleChanges): void {
    if (!value && !alerter) {
      return;
    }

    this.element.nativeElement.classList.remove(...AlerterDirective.ALERTER_STYLES);

    if (!this.alerter || !this.value || typeof this.value !== 'number') {
      return;
    }

    if (this.applyOperator(this.alerter.greenOperator, this.alerter.neutralValue, this.value)) {
      this.element.nativeElement.classList.add(AlerterStyles.GREEN);
    } else if (this.applyOperator(this.alerter.redOperator, this.alerter.neutralValue, this.value)) {
      this.element.nativeElement.classList.add(AlerterStyles.RED);
    }
  }

  private applyOperator(operator: AlerterOperator, neutral: number, value: number): boolean {
    switch (operator) {
      case AlerterOperators.GREATER_THAN:
        return value > neutral;

      case AlerterOperators.LESS_THAN:
        return value < neutral;
    }
    throw new Error('Not implemented.');
  }
}
